import React from "react";
import * as moment from "moment";

import "./transactionmodal.css";
import { Util } from "../../../../../../helpers/util";

const AllTransactionModal = ({ setTransac, selectedTransaction }) => {
  const { currency } = Util.getCurrency();

  return (
    <div className="alltransac-modal">
      <h5>Transaction Summary</h5>
      <p>Wallet deposit</p>

      <div className="summary-body">
        <div className="date-ses">
          <p className="date">
            Date:{" "}
            <span>
              {moment(selectedTransaction.created_at).format(
                "ddd, MMM DD YYYY"
              )}
            </span>{" "}
          </p>
          <p className="time">
            Time:
            <span>
              {moment(selectedTransaction.created_at).format("hh:mma")}
            </span>
          </p>
        </div>

        <div className="amount-ses">
          <p className="amount-summary">
            Amount:
            <span>
              {currency}
              {Math.abs(selectedTransaction.amount).toLocaleString()}
            </span>{" "}
          </p>
          <div>
            {/* <p className="pending">
              Status: <span>Pending</span>{" "}
            </p> */}
            <p className="processed">
              Status: <span>{selectedTransaction.status}</span>{" "}
            </p>
          </div>
        </div>
        <p className="reference">Reference: {selectedTransaction.reference}</p>
        <p className="payment-met">
          Payment Method: {selectedTransaction.payment_method}
        </p>
      </div>

      {/* <div className="receipt-btn">
        <button className="download-receipt">Download Receipt</button>
      </div> */}
    </div>
  );
};

export default AllTransactionModal;
